import React, { useState } from "react";
import { Dialog, FormControl, DialogTitle, Select, DialogContent, DialogActions, Button, withStyles, MenuItem } from '@material-ui/core';
import * as actions from './store/colliActions';
import { connect } from 'react-redux';
import { createHistory, parseURL } from '../../sc-utilities';
import { Redirect } from 'react-router-dom';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    buttonSafe: {
        '&:hover': {
            color: theme.palette.buttonText.default,
            backgroundColor: theme.palette.secondary.main,
            borderRadius: '1px'
        }
    },
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            borderRadius: '1px'
        }
    },
    formControl: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
        width: '90%'
    }
});


const ChooseColliType = props => {
    const { classes, colliType, handleClose, translations, warehouses } = props;
    const [type, setType] = useState(colliType.data && colliType.data.length > 0 ? colliType.data[0].value : ' ');
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, colliID: null, redirectPath: '' });
    let searchParams = parseURL(window.location.search);

    const submitHandler = () => {
        createHistory();
        setRedirectOptions({ redirect: true, redirectPath: `/logistic/warehouse/create?colliType=${type}${searchParams && searchParams.WarehouseInventoryID ? `&&WarehouseInventoryID=${warehouses.name[0].value}` : ''}` })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <Dialog open={colliType.open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}>
            <DialogTitle id="form-dialog-title">{translations["please_select_colli_type"] || "Please select colli type"}</DialogTitle>
            <DialogContent>
                <FormControl className={classes.formControl} margin={"dense"}>
                    <Select
                        name="active_warehouse"
                        label={translations["active_warehouse"] || "Active Warehouse"}
                        margin={"dense"}
                        value={type}
                        fullWidth={true}
                        onChange={(event) => setType(event.target.value)}
                    >
                        {(colliType && colliType.data.length > 0 ? colliType.data : []).map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.displayValue}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained" className={classes.buttonSafe}>
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button onClick={submitHandler} variant="contained" disabled={colliType.data instanceof Array && colliType.data.length < 1} className={classes.buttonDanger}>
                    {translations['submit'] || 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setActiveWarehouse: (params) => dispatch(actions.setActiveWarehouse(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ChooseColliType));

